import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource-variable/manrope'
import { App } from './app/App'
import { transportSeoManifest } from './transport/seo'
import './styles/index.css'

window.__SYRIA_BUS_TRANSPORT_SEO_MANIFEST__ = transportSeoManifest

const root = document.getElementById('root')!
const application = <StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>
if (root.hasChildNodes() && document.documentElement.dataset.prerendered === 'true') hydrateRoot(root, application)
else createRoot(root).render(application)
